import type { PropsWithChildren } from 'react';
import React from 'react';

import RequestAnimationFrame from './RequestAnimationFrame';

interface OnWindowScrollProps extends PropsWithChildren {
  onScroll: () => void;
}

export default class OnWindowScroll extends React.Component<OnWindowScrollProps> {
  windowPageYOffset = NaN;
  viewportHeight = NaN;

  scrollChanged = () => {
    if (this.windowPageYOffset !== window.pageYOffset) {
      this.windowPageYOffset = window.pageYOffset;

      return true;
    }

    return false;
  };

  viewportChanged =
    'visualViewport' in window
      ? () => {
          if (this.viewportHeight !== window.visualViewport.height) {
            this.viewportHeight = window.visualViewport.height;

            return true;
          }

          return false;
        }
      : () => false;

  onScroll = () => {
    if (this.scrollChanged() || this.viewportChanged()) {
      this.props.onScroll();
    }
  };

  render() {
    return (
      <RequestAnimationFrame onFrame={this.onScroll}>{this.props.children}</RequestAnimationFrame>
    );
  }
}
